import { useEffect, useState } from 'react';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import DesktopCardMenu from './DesktopCardMenu';
import MobileCardMenu from './MobileCardMenu';
import { useLocation } from 'quartz-routing/react-router';
import { VerticalMenuIcon } from 'foundations-assets/icons/components/VerticalMenuIcon';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { jsx as _jsx } from "react/jsx-runtime";
const CardMenuIcon = props => {
  const {
    use = 'tertiary-extra-light',
    size = 'small',
    onMenuIconClick
  } = props;
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const onIconClick = e => {
    e.preventDefault();
    setIsOpen(true);
    onMenuIconClick === null || onMenuIconClick === void 0 || onMenuIconClick(props.item);
  };
  const {
    isMobile
  } = useMediaQuery();
  const Component = isMobile ? MobileCardMenu : DesktopCardMenu;
  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setIsOpen(false);
  }, [location.pathname]);
  return /*#__PURE__*/_jsx("div", {
    onClick: e => {
      // XAVI: this line is preventing external links from opening
      // will be removed after refactoring the card menu
      e.stopPropagation();
    },
    children: /*#__PURE__*/_jsx(Component, Object.assign({}, props, {
      isOpen: isOpen,
      onOpenChange: setIsOpen,
      use: use,
      children: /*#__PURE__*/_jsx(IconButton, {
        "data-test-id": "card-menu-popover-button",
        onClick: onIconClick,
        size: size,
        use: use,
        children: /*#__PURE__*/_jsx(VerticalMenuIcon, {})
      })
    }))
  });
};
export default CardMenuIcon;